import { IRootState } from '../../../store'
import { IAssessmentProcedureOptionsState } from '../store/options.types'
export const getAssessmentOptionsSelector = (state: IRootState): IAssessmentProcedureOptionsState =>
  state.options.assessmentProcedureOptions
